import { RESTError } from "../core/RESTError";

/**
 * An error that occurs when no install guide could be loaded.
 */
export class MissingInstallGuideError extends RESTError {}
